import React, { Component } from "react";
import PropTypes from "prop-types";
import "./Default.css";
import { Link } from "react-router-dom";
import "../../screens/Common/cmnStyle.css";

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultFooter extends Component {
  render() {
    // eslint-disable-next-line
    const { children, ...attributes } = this.props;

    return (
      <React.Fragment>
        <div>
          <div
            style={{
              marginLeft: "10px",
              padding: "10px",
              textAlign: "center",
              width: "100%",
              marginLeft: "120px",
            }}
          >
            <span
              style={{
                fontSize: "12px",
                fontWeight: "500",
                opacity: "0.6",
                color: "#ffffff",
              }}
            >
              Copyright © {new Date().getFullYear()} by SmarterHomes Private
              Ltd. All Rights Reserved. {process.env.REACT_APP_VERSION}
            </span>
            <div
              style={{
                marginTop: "5px",
                // display: "flex",
                color: "#ffffff",
                gap: "8px",
                fontSize: "11px",
                flexWrap: "wrap",
                textAlign: "center",
              }}
            >
              <Link
                to="/termsandconditions"
                target="_blank"
                rel="noopener noreferrer"
                className="cmnTermFooterLink"
              >
                Terms & Conditions
              </Link>{" "}
              |{"  "}
              <Link
                to="/privacypolicy"
                target="_blank"
                rel="noopener noreferrer"
                className="cmnTermFooterLink"
              >
                Privacy Policy
              </Link>{" "}
              |{"  "}
              <Link
                to="/refundpolicy"
                target="_blank"
                rel="noopener noreferrer"
                className="cmnTermFooterLink"
              >
                Refund Policy
              </Link>{" "}
              |{"  "}
              <Link
                to="/contactus"
                target="_blank"
                rel="noopener noreferrer"
                className="cmnTermFooterLink"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

DefaultFooter.propTypes = propTypes;
DefaultFooter.defaultProps = defaultProps;

export default DefaultFooter;
